import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wwu-uipath',
  templateUrl: './uipath.component.html',
  styleUrls: ['./uipath.component.scss']
})
export class UiPathComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
